import React from 'react';
import Router from "./Router";
import GlobalStyles from "./GlobalStyles";

function App() {
  return (
    <div className="App">
      <Router/>
      <GlobalStyles/>
    </div>
  );
}

export default App;
